interface SetDocumentVariablesProps {
  variables: [string, string | number][]
  callback?: () => void
}

export const setDocumentVariables = (props: SetDocumentVariablesProps) => {
  const { variables, callback } = props

  variables.forEach(([key, value]) => {
    document.documentElement.style.setProperty(key, value.toString())
  })

  return () => {
    callback?.()

    variables.forEach(([key]) => {
      document.documentElement.style.removeProperty(key)
    })
  }
}
